// app/javascript/controllers/alert_controller.js
// Stimulus Controller: Flash-Meldungen automatisch ausblenden

import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    // Automatisch nach 4 Sekunden ausblenden
    this.timer = setTimeout(() => this.dismiss(), 4000)
  }

  disconnect() {
    clearTimeout(this.timer)
  }

  dismiss() {
    this.element.style.transition = "opacity .3s, transform .3s"
    this.element.style.opacity = "0"
    this.element.style.transform = "translateY(-8px)"
    setTimeout(() => this.element.remove(), 300)
  }
}
